<script>
import BaseView from "@/mixins/BaseView.vue";
import OrdersList from "./components/OrdersList.vue";
import OrdersListSearchForm from "./components/OrdersListSearchForm.vue";
import PageHeader from "@/components/header/PageHeader.vue";
import LinkButton from "@/components/buttons/LinkButton.vue";
import PermissionTooltip from "@/components/tooltips/PermissionTooltip.vue";
import { DispatcherPermissionValue } from "@/api/dto/dispatcher.dto.ts";

export default {
  name: "OrdersPage",
  components: { PermissionTooltip, LinkButton, PageHeader, OrdersListSearchForm, OrdersList },
  mixins: [BaseView],
  data() {
    return {
      perm: "orders",
      searchParams: {},
    };
  },
  computed: {
    DispatcherPermissionValue() {
      return DispatcherPermissionValue;
    },
  },
  created() {
    this.setTitle(this.$t("orders.orders"));
  },
  methods: {
    search(params) {
      this.searchParams = { ...params };
    },
  },
};
</script>

<template>
  <v-container :fluid="true" class="pt-6 pb-10 pl-6 pr-6 height-100 orders-page">
    <page-header :header="$t('orders.orders')">
      <template #suffix>
        <permission-tooltip :permission="DispatcherPermissionValue.OrdersEdit">
          <template #activator="{ disabled }">
            <link-button :disabled="disabled" :to="{ name: 'order-create' }" color="success">
              {{ $t("general.create-new") }}
            </link-button>
          </template>

          {{ $t("permission.create-order") }}
        </permission-tooltip>
      </template>
    </page-header>
    <orders-list-search-form @search="search" />
    <orders-list :search-params="searchParams" />
  </v-container>
</template>

<style lang="scss" scoped>
.orders-page {
  & > .v-card {
    background: transparent;
  }
}
</style>
